/**
 * Ingredients Section JavaScript
 * Handles filtering, carousel, and interactive functionality
 */

class IngredientsSection {
  constructor() {
    this.init();
  }

  init() {
    this.filterBtns = document.querySelectorAll('.ingredients__filter-btn');
    this.callouts = document.querySelectorAll('.ingredients__callout');
    this.lines = document.querySelectorAll('.ingredients__line');
    this.mobileItems = document.querySelectorAll('.ingredients__mobile-item');
    this.mobileScroller = document.getElementById('ingredients-mobile-scroller');
    this.mobileFilterSelect = document.getElementById('ingredients-concern-select');
    this.filtersContainer = document.querySelector('.ingredients__filters');
    this.mobileFilterType = this.filtersContainer ? this.filtersContainer.dataset.mobileType : 'dropdown';
    this.currentFilter = 'all';

    this.bindEvents();
    this.showInitialCallouts();
  }

  bindEvents() {
    // Filter button clicks
    this.filterBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const concern = btn.dataset.concern;
        this.filterByConcern(concern);
      });
    });

    // Mobile dropdown change (only if dropdown is enabled)
    if (this.mobileFilterType === 'dropdown' && this.mobileFilterSelect) {
      this.mobileFilterSelect.addEventListener('change', (e) => {
        const concern = e.target.value;
        this.filterByConcern(concern);
      });
    }

    // Resize handling removed - using simple scroller

    // Intersection Observer for animations
    this.setupIntersectionObserver();
  }

  filterByConcern(concern) {
    this.currentFilter = concern;

    // Update active filter button
    this.filterBtns.forEach(btn => {
      btn.classList.remove('active');
      if (btn.dataset.concern === concern) {
        btn.classList.add('active');
      }
    });

    // Update mobile dropdown selection (only if dropdown is enabled)
    if (this.mobileFilterType === 'dropdown' && this.mobileFilterSelect) {
      this.mobileFilterSelect.value = concern;
    }

    // Filter desktop callouts
    this.callouts.forEach(callout => {
      const calloutConcern = callout.dataset.concern;
      const individualConcerns = callout.dataset.concerns;
      const shouldShow = concern === 'all' || this.shouldShowItem(concern, calloutConcern, individualConcerns);
      
      if (shouldShow) {
        callout.style.display = 'flex';
        setTimeout(() => {
          callout.classList.add('active');
        }, 50);
      } else {
        callout.classList.remove('active');
        setTimeout(() => {
          callout.style.display = 'none';
        }, 300);
      }
    });

    // Filter lines
    this.lines.forEach(line => {
      const lineConcern = line.dataset.concern;
      const individualConcerns = line.dataset.concerns;
      const shouldShow = concern === 'all' || this.shouldShowItem(concern, lineConcern, individualConcerns);
      
      if (shouldShow) {
        line.style.display = 'block';
        line.classList.add('active');
      } else {
        line.classList.remove('active');
        setTimeout(() => {
          line.style.display = 'none';
        }, 300);
      }
    });

    // Filter mobile items
    this.mobileItems.forEach(item => {
      const itemConcern = item.dataset.concern;
      const individualConcerns = item.dataset.concerns;
      const shouldShow = concern === 'all' || this.shouldShowItem(concern, itemConcern, individualConcerns);
      
      item.style.display = shouldShow ? 'flex' : 'none';
    });

    // Mobile scroller filtering handled by CSS display property
  }

  shouldShowItem(selectedConcern, originalConcern, individualConcerns) {
    // If no individual concerns data, fall back to original behavior
    if (!individualConcerns) {
      return originalConcern === selectedConcern;
    }

    // Check if the selected concern matches any of the individual concerns
    const concernsArray = individualConcerns.split(',');
    return concernsArray.some(concern => {
      const cleanConcern = concern.trim();
      return cleanConcern === selectedConcern;
    });
  }

  showInitialCallouts() {
    // Show all callouts initially
    this.callouts.forEach(callout => {
      callout.style.display = 'flex';
      setTimeout(() => {
        callout.classList.add('active');
      }, 100);
    });

    this.lines.forEach(line => {
      line.style.display = 'block';
      line.classList.add('active');
    });
  }

  // Mobile callout functionality removed - using simple scroller instead

  setupIntersectionObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe callouts for animation
    this.callouts.forEach(callout => {
      observer.observe(callout);
    });
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Public method to update filter programmatically
  setFilter(concern) {
    this.filterByConcern(concern);
  }

  // Public method to get current filter
  getCurrentFilter() {
    return this.currentFilter;
  }

  // Public method to destroy instance
  destroy() {
    this.filterBtns.forEach(btn => {
      btn.removeEventListener('click', this.filterByConcern);
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Check if ingredients section exists
  if (document.querySelector('.ingredients')) {
    window.ingredientsSection = new IngredientsSection();
  }
});

// Export for module systems
if (typeof module !== 'undefined' && module.exports) {
  module.exports = IngredientsSection;
}
